module.exports = __webpack_public_path__ + "static/media/Ashmayu_Balloon_W.e0c958e3.png";